import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useUserStore = create(
  persist(
    (set, get) => ({
      user: null,

      // Actions
      setUser: newData => {
        const existingUser = get().user || {}
        set({
          user: {
            ...existingUser,
            ...newData
          }
        })
      },

      resetUser: () => set({ user: null })
    }),
    {
      name: 'user-storage' // Optional: key name in storage
    }
  )
)

export default useUserStore
